module.exports = __webpack_public_path__ + "static/media/Icons-02.64f982bb.svg";